/* MATLEON — movimiento e interacción (vanilla, sin librerías)
   - Portada revista: profundidad con el ratón y al bajar; el flotado se pausa fuera de pantalla.
   - Círculo "VER" que sigue al ratón · Marcas con su tenis flotando · Luz en Premium · Cinta que reacciona al bajar
   - Transición entre páginas (la foto tocada vuela hasta la ficha)
   Todo respeta "menos movimiento" y en el editor de Shopify queda quieto. Solo se escribe translate/rotate/opacity,
   en un solo requestAnimationFrame que se detiene cuando ya no hay nada que mover. */
(function () {
  'use strict';
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  var raton = window.matchMedia('(hover: hover) and (pointer: fine)');
  var editor = document.documentElement.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
  function lerp(a, b, t) { return a + (b - a) * t; }

  /* ---------- Portada revista: capas a distinta profundidad ----------
     x, y: cuántos px se mueve con el ratón de un lado al otro de la pantalla
     s: cuánto se mueve al bajar por cada px de scroll (+ = más lento que la página, se siente lejos; − = más rápido, cerca)
     r: cuánto gira (grados) cuando ya se bajó toda la portada */
  function initRevista() {
    var rv = document.querySelector('[data-mt-revista]');
    if (!rv || rv.dataset.mtListo) return;
    rv.dataset.mtListo = '1';
    var visible = true, raf = 0;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        rv.classList.toggle('mt-rv--quieto', !visible);
        if (visible) pedir();
      }).observe(rv);
    }
    if (!rv.classList.contains('mt-rv--profundidad') || reducido.matches || editor) return;

    var frente = { x: 30, y: 18, s: -0.18, r: -6 };
    var capas = [];
    function capa(sel, f) { rv.querySelectorAll(sel).forEach(function (el) { capas.push({ el: el, x: f.x, y: f.y, s: f.s, r: f.r }); }); }
    capa('[data-mt-capa="atras"]', { x: 16, y: 10, s: 0.2, r: 5 });
    capa('[data-mt-capa="titulo"]', { x: -6, y: -4, s: 0.07, r: 0 });
    capa('[data-mt-capa="frente"]', frente);
    // La notita y su flecha van "pegadas" al tenis grande: así la flecha siempre lo señala
    capa('.mt-rv__nota', frente);
    capa('.mt-rv__escena > .mt-garabato', frente);
    if (!capas.length) return;

    var tx = 0, ty = 0, cx = 0, cy = 0, ultimoY = -1, alto = rv.offsetHeight || 1;
    window.addEventListener('resize', function () { alto = rv.offsetHeight || 1; pedir(); });
    function pedir() { if (!raf && visible) raf = requestAnimationFrame(cuadro); }
    function cuadro() {
      raf = 0;
      cx = lerp(cx, tx, 0.075); cy = lerp(cy, ty, 0.075);
      var y = window.scrollY, p = Math.min(1.2, Math.max(0, y / alto));
      for (var i = 0; i < capas.length; i++) {
        var c = capas[i];
        c.el.style.translate = (cx * c.x).toFixed(2) + 'px ' + (cy * c.y + y * c.s).toFixed(2) + 'px';
        if (c.r) c.el.style.rotate = (p * c.r).toFixed(2) + 'deg';
      }
      var sigue = Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001 || y !== ultimoY;
      ultimoY = y;
      if (sigue) pedir();
    }
    window.addEventListener('scroll', pedir, { passive: true });
    if (raton.matches) {
      window.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        tx = (e.clientX / window.innerWidth) * 2 - 1;
        ty = (e.clientY / window.innerHeight) * 2 - 1;
        pedir();
      }, { passive: true });
      document.documentElement.addEventListener('mouseleave', function () { tx = 0; ty = 0; pedir(); });
    }
    pedir();
  }

  /* ---------- Círculo "VER" que sigue al ratón sobre productos, categorías y tenis de la portada ----------
     Aparece justo donde está el ratón (no viaja desde lejos), lo sigue con un poco de retraso y se encoge al hacer clic.
     Sobre tarjetas oscuras se vuelve claro. Solo con ratón. */
  function initCursor() {
    if (!raton.matches || reducido.matches || editor || document.querySelector('.mt-cursor')) return;
    var c = document.createElement('div');
    c.className = 'mt-cursor'; c.setAttribute('aria-hidden', 'true'); c.textContent = 'Ver';
    document.body.appendChild(c);
    document.documentElement.classList.add('mt-con-cursor');
    var SEL = '.card-wrapper, .mt-cat, .mt-rv__zapato';
    var x = -300, y = -300, cx = x, cy = y, raf = 0, activo = null, revisar = 0;
    function cuadro() {
      raf = 0;
      cx = lerp(cx, x, 0.22); cy = lerp(cy, y, 0.22);
      c.style.translate = cx.toFixed(1) + 'px ' + cy.toFixed(1) + 'px';
      if (Math.abs(cx - x) > 0.1 || Math.abs(cy - y) > 0.1) raf = requestAnimationFrame(cuadro);
    }
    function sobre(t) {
      if (t === activo) return;
      if (!activo && t) { cx = x; cy = y; }
      activo = t;
      c.classList.toggle('mt-cursor--on', !!t);
      c.classList.toggle('mt-cursor--claro', !!(t && (t.classList.contains('mt-cat--oscuro') || t.closest('.mt-oscuro'))));
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      sobre(e.target.closest ? e.target.closest(SEL) : null);
      if (!raf) raf = requestAnimationFrame(cuadro);
    }, { passive: true });
    // Al bajar con la rueda sin mover el ratón, lo que queda debajo cambia
    window.addEventListener('scroll', function () {
      if (revisar) return;
      revisar = requestAnimationFrame(function () {
        revisar = 0;
        var el = document.elementFromPoint(x, y);
        sobre(el && el.closest ? el.closest(SEL) : null);
      });
    }, { passive: true });
    document.addEventListener('pointerdown', function () { if (activo) c.classList.add('mt-cursor--abajo'); });
    document.addEventListener('pointerup', function () { c.classList.remove('mt-cursor--abajo'); });
    document.documentElement.addEventListener('mouseleave', function () { sobre(null); });
  }

  /* ---------- Marcas: el tenis de la marca flota junto al ratón y se inclina según la velocidad ---------- */
  function initMarcasVista() {
    if (!raton.matches || reducido.matches || editor) return;
    document.querySelectorAll('.mt-marcas--lista .mt-marcas__lista').forEach(function (lista) {
      if (lista.dataset.mtVista || !lista.querySelector('a[data-mt-foto]')) return;
      lista.dataset.mtVista = '1';
      var v = document.createElement('div');
      v.className = 'mt-marca-vista'; v.setAttribute('aria-hidden', 'true');
      document.body.appendChild(v);
      var fotos = {};
      function foto(url) {
        if (!fotos[url]) { var i = new Image(); i.decoding = 'async'; i.alt = ''; i.src = url; v.appendChild(i); fotos[url] = i; }
        return fotos[url];
      }
      // Precarga al acercarse a la lista, así la primera vista ya está lista
      lista.addEventListener('pointerenter', function () { lista.querySelectorAll('a[data-mt-foto]').forEach(function (a) { foto(a.dataset.mtFoto); }); }, { once: true });
      var x = 0, y = 0, cx = 0, cy = 0, raf = 0, activo = null;
      function cuadro() {
        raf = 0;
        var antes = cx;
        cx = lerp(cx, x, 0.13); cy = lerp(cy, y, 0.13);
        var giro = Math.max(-14, Math.min(14, (cx - antes) * 0.55));
        v.style.translate = cx.toFixed(1) + 'px ' + cy.toFixed(1) + 'px';
        v.style.rotate = (-8 + giro).toFixed(2) + 'deg';
        if (Math.abs(cx - x) > 0.1 || Math.abs(cy - y) > 0.1) raf = requestAnimationFrame(cuadro);
      }
      lista.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        x = e.clientX + Math.min(260, window.innerWidth * 0.18); y = e.clientY;
        var a = e.target.closest('a');
        if (a !== activo) {
          activo = a;
          var url = a && a.dataset.mtFoto;
          Object.keys(fotos).forEach(function (k) { fotos[k].classList.remove('mt-activa'); });
          if (url) {
            if (!v.classList.contains('mt-marca-vista--on')) { cx = x; cy = y; }
            foto(url).classList.add('mt-activa');
            v.classList.add('mt-marca-vista--on');
          } else v.classList.remove('mt-marca-vista--on');
        }
        if (!raf) raf = requestAnimationFrame(cuadro);
      }, { passive: true });
      lista.addEventListener('pointerleave', function () { activo = null; v.classList.remove('mt-marca-vista--on'); });
      window.addEventListener('scroll', function () { activo = null; v.classList.remove('mt-marca-vista--on'); }, { passive: true });
    });
  }

  /* ---------- Premium: luz que sigue al ratón y la M de fondo más lenta que la página ---------- */
  function initPremium() {
    if (reducido.matches || editor) return;
    document.querySelectorAll('[data-mt-premium]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';
      var luz = raton.matches ? sec.querySelector('.mt-premium__luz') : null;
      var iso = sec.querySelector('[data-mt-paralaje]');
      var f = iso ? parseFloat(iso.dataset.mtParalaje) || 0.1 : 0;
      var visible = false, raf = 0, x = 0, y = 0, cx = 0, cy = 0;
      function pedir() { if (!raf && visible) raf = requestAnimationFrame(cuadro); }
      function cuadro() {
        raf = 0;
        if (iso) {
          var r = sec.getBoundingClientRect();
          iso.style.translate = '0 ' + (-(r.top + r.height / 2 - window.innerHeight / 2) * f).toFixed(1) + 'px';
        }
        if (luz) {
          cx = lerp(cx, x, 0.09); cy = lerp(cy, y, 0.09);
          luz.style.translate = cx.toFixed(1) + 'px ' + cy.toFixed(1) + 'px';
          if (Math.abs(cx - x) > 0.2 || Math.abs(cy - y) > 0.2) pedir();
        }
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; pedir(); }).observe(sec);
      window.addEventListener('scroll', pedir, { passive: true });
      if (luz) {
        var donde = function (e) { var r = sec.getBoundingClientRect(); x = e.clientX - r.left; y = e.clientY - r.top; };
        sec.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; donde(e); cx = x; cy = y; sec.classList.add('mt-premium--luz'); pedir(); });
        sec.addEventListener('pointermove', function (e) { if (e.pointerType !== 'mouse') return; donde(e); pedir(); }, { passive: true });
        sec.addEventListener('pointerleave', function () { sec.classList.remove('mt-premium--luz'); });
      }
    });
  }

  /* Cinta: ya no se acelera ni se inclina al bajar (el dueño lo vio como falla, 2026-10-25). Va a paso fijo: mt-scripts.js */

  /* ---------- Transición entre páginas: la foto tocada vuela hasta la ficha ----------
     Aquí (página que se va) se le pone nombre a la foto tocada y se guarda el producto; en la ficha, un script en <head>
     (theme.liquid, pagereveal) le pone el mismo nombre a su foto principal. */
  var ultimoToque = null;
  document.addEventListener('click', function (e) { ultimoToque = e.target; }, true);
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition || !e.activation || !ultimoToque || !ultimoToque.closest) return;
    // Celular: sin foto voladora. Ahí la foto llegaba completa ANTES que el resto de la página (se veía brusco);
    // así toda la ficha entra junta con el fundido de la página.
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    var destino;
    try { destino = new URL(e.activation.entry.url); } catch (err) { return; }
    var m = destino.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var zona = ultimoToque.closest('.card-wrapper, .mt-rv__zapato');
    var img = zona && zona.querySelector('img');
    if (!img) return;
    img.style.viewTransitionName = 'mt-producto';
    try { sessionStorage.setItem('mt-vt-producto', decodeURIComponent(m[1])); } catch (err) {}
  });
  // Si se regresa con "atrás" y la página sale de la memoria del navegador, se limpia el nombre
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('img[style*="view-transition-name"]').forEach(function (i) { i.style.viewTransitionName = ''; });
  });

  /* ---------- Edición de temporada: con la fecha del visitante ----------
     La portada ya llega con la temporada calculada en Shopify; pero si la página quedó guardada de otro día
     (justo al cambiar de temporada), aquí se corrige antes de que se dibuje el garabato. Mismas fechas que en
     sections/mt-hero.liquid: primavera 20 mar · verano 21 jun · otoño 23 sep · invierno 21 dic. */
  var ESTACIONES = {
    primavera: { nombre: 'Primavera', glifo: 'brote' }, verano: { nombre: 'Verano', glifo: 'sol' },
    otono: { nombre: 'Otoño', glifo: 'hoja' }, invierno: { nombre: 'Invierno', glifo: 'copo' }
  };
  function estacionDe(d) {
    var md = (d.getMonth() + 1) * 100 + d.getDate(), a = d.getFullYear() % 100, e;
    if (md >= 1221 || md < 320) { e = 'invierno'; if (md < 320) a = (a + 99) % 100; }
    else if (md < 621) e = 'primavera';
    else if (md < 923) e = 'verano';
    else e = 'otono';
    return { e: e, a: ('0' + a).slice(-2) };
  }
  // Igual que snippets/mt-letras.liquid
  function armarLetras(caja, texto) {
    var letras = Array.from(texto), mitad = (letras.length - 1) / 2, html = '';
    letras.forEach(function (l, j) {
      var r = j % 2 === 0 ? -(22 + (j % 3) * 9) : 18 + (j % 3) * 8, x = j % 2 === 0 ? -7 : 6;
      html += l === ' ' ? '<span class="mt-ed__esp"> </span>'
        : '<span class="mt-ed__l" style="--j:' + j + ';--c:' + Math.round(Math.abs(j - mitad)) + ';--r:' + r + 'deg;--x:' + x + 'px">' + l + '</span>';
    });
    caja.innerHTML = html;
  }
  function initEdicion() {
    document.querySelectorAll('[data-mt-edicion]:not([data-forzada])').forEach(function (ed) {
      var hoy = estacionDe(new Date()), info = ESTACIONES[hoy.e];
      var texto = 'Edición ' + info.nombre + ' ’' + hoy.a;
      if (ed.dataset.estacion === hoy.e && ed.getAttribute('aria-label') === texto) return;
      ed.classList.remove('mt-ed--' + ed.dataset.estacion);
      ed.classList.add('mt-ed--' + hoy.e);
      ed.dataset.estacion = hoy.e;
      ed.setAttribute('aria-label', texto);
      armarLetras(ed.querySelector('.mt-ed__txt'), texto);
      var glifo = ed.querySelector('.mt-ed__glifo'), g = glifo && glifo.querySelector('.mt-garabato');
      if (g) {
        glifo.className = 'mt-ed__glifo mt-ed__glifo--' + info.glifo;
        g.className = g.className.replace(/mt-garabato--(hoja|copo|brote|sol)/, 'mt-garabato--' + info.glifo);
        g.setAttribute('data-g', info.glifo);
      }
    });
  }

  /* ---------- Confianza: cada icono se dibuja trazo por trazo cuando su garantía aparece ----------
     Largo de cada trazo medido en px (getTotalLength), sin pathLength (falla en iPhone). */
  function initIconos() {
    if (reducido.matches || editor) return;
    document.querySelectorAll('.mt-conf__item.mt-reveal:not(.mt-visible) .mt-conf__icono').forEach(function (svg) {
      if (svg.dataset.mtListo) return;
      svg.dataset.mtListo = '1';
      var trazos = Array.prototype.filter.call(svg.querySelectorAll('path, circle, rect'), function (p) { return p.getTotalLength; });
      trazos.forEach(function (p) { var L = p.getTotalLength() + 1; p.style.strokeDasharray = L; p.style.strokeDashoffset = L; p._L = L; });
      var item = svg.closest('.mt-reveal');
      var mo = new MutationObserver(function () {
        if (!item.classList.contains('mt-visible')) return;
        mo.disconnect();
        var espera = (parseFloat(getComputedStyle(item).getPropertyValue('--mt-delay')) || 0) * 1000 + 250;
        trazos.forEach(function (p, i) {
          p.animate([{ strokeDashoffset: p._L }, { strokeDashoffset: 0 }], { duration: 1300, delay: espera + 150 + i * 260, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'both' });
        });
      });
      mo.observe(item, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---------- Cierre: la M se pinta cuando su SECCIÓN aparece ----------
     (la M recortada al 100 % no cuenta como visible para el navegador, por eso se vigila la sección) */
  // La pinta la brocha (assets/mt-brocha.js): pincelada por pincelada con cerdas y ritmo de mano, y al terminar una
  // luz baja desde arriba y prende las cerdas de la pintura (la "luz real" de los videos). Todo son animaciones del navegador
  // programadas de una vez (se puede revisar cuadro por cuadro con video/cuadros).
  function initPincel() {
    var m = document.querySelector('.mt-cierre__iso[data-mt-pincel]');
    if (!m || m.dataset.mtListo) return;
    m.dataset.mtListo = '1';
    var svg = m.querySelector('[data-mt-brocha]');
    if (!svg || !window.MTBrocha) return;
    if (!('IntersectionObserver' in window) || reducido.matches || editor) return;   // se queda completa, sin pintar
    var obra = MTBrocha.preparar(svg);                                         // escondida hasta que llegue
    if (!obra) return;
    var src = svg.querySelector('image').getAttribute('href');
    var sec = m.closest('.mt-cierre') || m.parentElement;
    var io = new IntersectionObserver(function (e) {
      if (!e[0].isIntersecting) return;
      io.disconnect();
      var fin = MTBrocha.pintar(obra, { inicio: 120 });
      // La luz definitiva (la misma de los videos): brilla sobre las cerdas de la pintura, no es una raya encima
      var finLuz = MTBrocha.brillo(m, src, fin - 40, { oscuro: !!m.closest('.mt-oscuro'), forma: 'real', obra: obra, intensidad: 1.6 });
      // Ya pintada, la M se cambia por la imagen sola: las cerdas, máscaras y la capa de luz que quedan en la página
      // hacían que el iPhone la volviera a dibujar en cada cuadro cuando algo de arriba cambia de alto
      // (las preguntas frecuentes al abrirse) y ahí se trababa. Al final la luz ya salió, así que se ve idéntica.
      setTimeout(function () {
        var img = new Image();
        img.src = src; img.alt = ''; img.setAttribute('aria-hidden', 'true');
        img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain';
        (img.decode ? img.decode() : Promise.resolve()).catch(function () {}).then(function () {
          m.textContent = '';
          m.appendChild(img);
        });
      }, finLuz + 200);
    }, { rootMargin: '0px 0px -22% 0px', threshold: 0 });
    io.observe(sec);
  }

  /* ---------- Pie: MATLEON gigante, letra por letra, al ritmo con que se baja ----------
     Cada letra sube desde la ranura según cuánto de la caja ya se ve (no por tiempo): si se baja despacio, sube despacio;
     si se detiene, se detiene. Las letras van escalonadas como ola (M primero, N al final) y siguen el scroll con un
     pequeño retraso suave, así el movimiento nunca se ve brusco. */
  function initGigante() {
    var caja = document.querySelector('[data-mt-gigante]');
    if (!caja || caja.dataset.mtListo) return;
    caja.dataset.mtListo = '1';
    if (reducido.matches || editor) return;
    var letras = Array.prototype.slice.call(caja.querySelectorAll('.mt-gigante__l'));
    var n = letras.length, ESCALON = 0.075, actual = letras.map(function () { return 1; }), raf = 0, visible = false;
    function suave(t) { return 1 - Math.pow(1 - t, 3); }
    function objetivo(i) {
      var r = caja.getBoundingClientRect();
      // 0 = recién asoma · 1 = se llegó al final de la página (usa todo el recorrido que queda, también en celular)
      var abajo = document.documentElement.scrollHeight - (r.bottom + window.scrollY);
      var p = (window.innerHeight - r.top) / Math.max(40, r.height + abajo - 4);
      var q = Math.max(0, Math.min(1, (p - i * ESCALON) / (1 - (n - 1) * ESCALON)));
      return 1 - suave(q);                                                   // 1 = escondida abajo · 0 = en su lugar
    }
    function pintar() {
      raf = 0;
      var sigue = false;
      letras.forEach(function (l, i) {
        var o = objetivo(i);
        actual[i] += (o - actual[i]) * 0.14;
        if (Math.abs(o - actual[i]) > 0.0008) sigue = true; else actual[i] = o;
        l.style.translate = '0 ' + (actual[i] * 106).toFixed(2) + '%';
      });
      if (sigue || visible) raf = sigue ? requestAnimationFrame(pintar) : 0;
    }
    function pedir() { if (!raf) raf = requestAnimationFrame(pintar); }
    letras.forEach(function (l, i) { actual[i] = objetivo(i); l.style.translate = '0 ' + (actual[i] * 106).toFixed(2) + '%'; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) pedir(); }, { rootMargin: '0px 0px 200px 0px' }).observe(caja);
    }
    window.addEventListener('scroll', function () { if (visible) pedir(); }, { passive: true });
    window.addEventListener('resize', pedir);
  }

  /* ---------- Categorías (computadora): la foto se mueve un poco dentro de la tarjeta, como una ventana ---------- */
  function initVentanas() {
    if (!raton.matches || reducido.matches || editor) return;
    document.querySelectorAll('.mt-cat').forEach(function (cat) {
      var img = cat.querySelector('.mt-cat__img, .mt-cat__recorte, .mt-cat__gofrado');
      if (!img || cat.dataset.mtVentana) return;
      cat.dataset.mtVentana = '1';
      var x = 0, y = 0, cx = 0, cy = 0, raf = 0;
      function cuadro() {
        raf = 0;
        cx = lerp(cx, x, 0.1); cy = lerp(cy, y, 0.1);
        img.style.translate = cx.toFixed(2) + 'px ' + cy.toFixed(2) + 'px';
        if (Math.abs(cx - x) > 0.05 || Math.abs(cy - y) > 0.05) raf = requestAnimationFrame(cuadro);
      }
      cat.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = cat.getBoundingClientRect();
        x = -((e.clientX - r.left) / r.width - 0.5) * 18;
        y = -((e.clientY - r.top) / r.height - 0.5) * 14;
        if (!raf) raf = requestAnimationFrame(cuadro);
      }, { passive: true });
      cat.addEventListener('pointerleave', function () { x = 0; y = 0; if (!raf) raf = requestAnimationFrame(cuadro); });
    });
  }

  function init() { initEdicion(); initIconos(); initPincel(); initGigante(); initVentanas(); initRevista(); initCursor(); initMarcasVista(); initPremium(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
